import React, { useState, useEffect, useContext } from 'react';
import { AdminContext } from '../../contexts/admin.context';
import { useTranslation } from 'react-i18next';
import { getTranslation } from '../../utils/translation';

function UserGuide() {
  const [buttonLinks, setButtonLinks] = useState([]);

  const {
    themeId,
    teamType,
    tRegion,
    user,
    portalConfig: { adminPanelTabs } = {}
  } = useContext(AdminContext);

  const mod = !user?.administrator && user?.moderator ? 'mod' : '';

  const { t } = useTranslation();

  useEffect(() => {
    try {
      const region = tRegion && tRegion !== '' ? tRegion : 'default';
      const guideTab = adminPanelTabs?.[region]?.find((tab) => tab.id === 'guide');
      if (!guideTab) return;

      const buttons = t(`${teamType}.guide`, { returnObjects: true })?.links || [];
      setButtonLinks(buttons);
    } catch (error) {
      console.log(error);
    }
  }, [adminPanelTabs]);

  console.log(buttonLinks);

  return (
    <div className="w-full mini-scrollbar overflow-y-auto">
      <section
        className="mb-8"
        dangerouslySetInnerHTML={{ __html: getTranslation(t, 'guide.body') }}
      />

      <div className="mb-8">
        <p
          className="font-bold"
          dangerouslySetInnerHTML={{ __html: getTranslation(t, 'guide.header') }}
        />
        {buttonLinks.map(({ title, url, info }, index) => {
          if (
            (title?.[`${tRegion}_${mod}`] !== undefined && !title?.[`${tRegion}_${mod}`]) ||
            (title?.[tRegion] !== undefined && !title?.[tRegion]) ||
            (title?.[`${themeId}_${mod}`] !== undefined && !title?.[`${themeId}_${mod}`]) ||
            (title?.[themeId] !== undefined && !title?.[themeId]) ||
            (title?.[`default_${mod}`] !== undefined && !title?.[`default_${mod}`])
          )
            return null;

          const finalTitle =
            title?.[`${tRegion}_${mod}`] ||
            title?.[tRegion] ||
            title?.[`${themeId}_${mod}`] ||
            title?.[themeId] ||
            title?.[`default_${mod}`] ||
            title?.default;

          const finalURL =
            url?.[`${tRegion}_${mod}`] ||
            url?.[tRegion] ||
            url?.[`${themeId}_${mod}`] ||
            url?.[themeId] ||
            url?.[`default_${mod}`] ||
            url?.default;

          const finalInfo =
            info?.[`${tRegion}_${mod}`] ||
            info?.[tRegion] ||
            info?.[`${themeId}_${mod}`] ||
            info?.[themeId] ||
            info?.[`default_${mod}`] ||
            info?.default;

          if (!finalTitle || !finalURL) return null;

          return (
            <div key={index} className="mt-4">
              <a
                href={finalURL}
                target="_blank"
                className="inline-block bg-cwhite-secondary px-5 py-2 rounded-md text-black text-lg font-semibold underline mb-2"
                rel="noreferrer">
                <span
                  dangerouslySetInnerHTML={{
                    __html: finalTitle
                  }}
                />
              </a>

              {finalInfo && (
                <p
                  className="mt-2 text-cblack-primary font-normal text-base"
                  dangerouslySetInnerHTML={{
                    __html: finalInfo
                  }}
                />
              )}
            </div>
          );
        })}
      </div>

      <div dangerouslySetInnerHTML={{ __html: getTranslation(t, 'guide.bottom') }} />
    </div>
  );
}

export default UserGuide;
